import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import { useTranslation } from "react-i18next";
import { Controller, UseFormMethods, FieldError } from "react-hook-form";
import { BUILDING_TYPES } from "../../constants";

interface IBuildingTypes {
    control: UseFormMethods["control"];
    prefix?: string;
    error: FieldError | undefined;
    disabled: boolean;
}

export const BuildingTypeDropdown = (props: IBuildingTypes) => {
    const { t } = useTranslation(["address", "validation"]);
    const { control, error, prefix, disabled } = props;

    const namePrefix = prefix ? `${prefix}.` : "";
    const idPrefix = prefix ? `${prefix}-` : "";
    const buildingTypesList = BUILDING_TYPES.map((buildingType: any) => ({
        value: buildingType,
        label: t(buildingType),
    }));

    return (
        <Controller
            control={control}
            name={`${namePrefix}buildingType`}
            rules={{
                required: t("validation:required"),
            }}
            render={(renderProps) => (
                <TextField
                    disabled={disabled}
                    className="xtest_title_input"
                    fullWidth
                    error={Boolean(error)}
                    helperText={error?.message}
                    id={`${idPrefix}buildingType`}
                    inputRef={renderProps.ref}
                    label={`${t("address:buildingType")} *`}
                    margin="dense"
                    name={renderProps.name}
                    select
                    value={renderProps.value || ""}
                    onChange={(event) => {
                        return renderProps.onChange(event);
                    }}
                >
                    {buildingTypesList.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField>
            )}
        />
    );
};
